import { Button } from "@/components/ui/button";
import Dialog from "@/components/ui/dialog";
import { ExternalLink } from "lucide-react";

const CreateAppViaDocumentation = () => {
  return (
    <div className="mt-4 grid grid-cols-[20%_1fr] items-center gap-4">
      <Dialog.Description className="ml-2 col-start-2 text-sm">
        Follow our
        <Button variant="link" size="inline">
          <a
            data-testid="noAppsInOrganizationCardLink"
            href="https://www.numerous.com/docs/quick-start"
            target="_blank"
            rel="noreferrer"
            className="flex items-center"
          >
            documentation
            <ExternalLink size={12} className="ml-1 inline" />
          </a>
        </Button>
        on how to deploy your own project to Numerous.
      </Dialog.Description>
    </div>
  );
};

export default CreateAppViaDocumentation;
